import { Box, TableCell, TableRow, Tooltip, Typography } from "@mui/material"
import { If } from "lib/@components/if"
import Iconify from "minimals-template/components/Iconify"
import { navigate } from "lib/routes/navigate"
import { uniqueId } from "library/database/split-id.mjs"
import { ResolutionStatusChip } from "routes/schedule/plugins/legislation-resolutions/resolution-status-chip"
import { CriticalityIcon } from "routes/schedule/plugins/legislation-resolutions/criticality-icon"
import { ChangeTypeSummaryIcons } from "routes/schedule/plugins/legislation-resolutions/change-type-summary-icons"

export function CopResolutionListRow({ item }) {
    const changes = item.proposedChanges ?? []
    const decided = changes.filter((c) => c.decision != null).length
    const hasChanges = item.status === "complete" || item.status === "applied"
    const flagged = !!item.flaggedForReview

    return (
        <TableRow hover sx={{ cursor: "pointer" }} onClick={handleNavigate}>
            <TableCell sx={{ width: 40, pr: 0 }}>
                <Tooltip title={flagged ? "Has changes flagged for review" : ""}>
                    <Box
                        sx={{ width: 28, height: 28, display: "flex", alignItems: "center", justifyContent: "center" }}
                    >
                        <If truthy={flagged}>
                            <Iconify icon="eva:flag-fill" sx={{ color: "warning.main" }} />
                        </If>
                    </Box>
                </Tooltip>
            </TableCell>
            <TableCell>
                <Typography variant="body2" fontWeight="bold">
                    {item.code}
                </Typography>
            </TableCell>
            <TableCell>{item.title}</TableCell>
            <TableCell>
                <ResolutionStatusChip status={item.status} />
            </TableCell>
            <TableCell>
                <ChangeTypeSummaryIcons changes={changes} />
            </TableCell>
            <TableCell>
                <CriticalityIcon criticality={item.criticality} />
            </TableCell>
            <TableCell>{hasChanges ? changes.length : "—"}</TableCell>
            <TableCell>{hasChanges ? `${decided} / ${changes.length}` : "—"}</TableCell>
        </TableRow>
    )

    function handleNavigate() {
        navigate(`/app/cop-resolution/${uniqueId(item._id)}`)
    }
}
